import React from "react";
import Container from "@mui/material/Container";
import { BookData } from "../../data/BookData";
import { HoverCard } from "../card/HoverCard";

export const BookList = () => {
  const renderBookList = () => {
    return BookData.map((item, index) => (
      <div style={{ margin: "8px", display: "flex" }} key={item.title}>
        <HoverCard {...item} />
      </div>
    ));
  };
  return (
    <Container maxWidth="lg">
      <div className="book-card-container">{renderBookList()}</div>
    </Container>
  );
};
